import { useTranslation } from 'react-i18next';

export const keyPrefix = 'confirm_attach_department_groups';
export const useConfirmAttachDepartmentGroupsTranslation = () => useTranslation('entities', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title: 'Добавление группы',
    details: 'Эта группа уже принадлежит подразделению {{departmentName}}. После добавления она будет откреплена от него. Вы уверены?',
    reject: 'Отмена',
    confirm: 'Добавить',
    unknown_title: 'Название неизвестно',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title: 'Add group',
    details: 'This group already belongs to the department {{departmentName}}. After adding it, it will be detached from it. Are you sure?',
    reject: 'Cancel',
    confirm: 'Add',
    unknown_title: 'Name unknown',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title: 'Agregar grupo',
    details: 'Este grupo ya pertenece al departamento {{departmentName}}. Después de agregarlo, se desvinculará de él. ¿Está seguro?',
    reject: 'Cancelar',
    confirm: 'Agregar',
    unknown_title: 'Anónimo',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title: 'Adicionar grupo',
    details: 'Este grupo já pertence ao departamento {{departmentName}}. Depois de adicioná-lo, ele será desvinculado. Tem certeza?',
    reject: 'Cancelar',
    confirm: 'Adicionar',
    unknown_title: 'Nome desconhecido',
  },
}) : {}) as Record<string, unknown>;
